import Portal = require("portal-gis");
import Collection = require("../collections/base-collection");
let data = new Collection<Portal.MapLayerLeaf>();
export = data; 